// extracted by mini-css-extract-plugin
export default {"text_input":"TextInput_text_input__BQ25I","read_text_input":"TextInput_read_text_input__WoThb"};